import app from '../../scripts/app';
import template from './button-clear.jade';
import buttonClearCtrl from './button-clear.controller';

app.directive('cianAfButtonClear', () => {
  return {
    template,
    scope: {},
    bindToController: {
      clearAction: '&',
      reportAction: '&',
    },
    controller: buttonClearCtrl,
    controllerAs: 'buttonClearCtrl',
    replace: true,
  };
});
